import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./AdminDashboardPage.css";
import { Users, FolderKanban, Briefcase } from "lucide-react";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
};

const formatTime = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

export default function AdminDashboardPage() {

  const navigate = useNavigate();

  const [currentUser, setCurrentUser] = useState({
    fullname: "",
    systemRole: "",
  });

  const [serverTime, setServerTime] = useState({
    fullDateTime: "",
  });

  const [stats, setStats] = useState({
    totalApprovedAlumni: 0,
    totalJobs: 0,
    totalProjects: 0,
  });

  const [loading, setLoading] = useState(true);

  // Load current user
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setCurrentUser({
        fullname: user.fullname,
        systemRole: user.systemRole,
      });
    }
  }, []);

  // Fetch server time
  const fetchServerTime = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/time/datetime`);
      if (res.data.success) {
        setServerTime(res.data);
      }
    } catch (err) {
      console.error("Failed to fetch server time:", err.message);
    }
  };

  // Fetch dashboard stats
  const fetchDashboardStats = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/dashboard/stats`);
      setStats(res.data);
    } catch (err) {
      console.error("Failed to fetch dashboard stats:", err.message);
    }
  };

  useEffect(() => {
    fetchServerTime();
    fetchDashboardStats();

    const timer = setTimeout(() => setLoading(false), 800);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="admin-dashboard-page">

      {/* USER INFO */}
      <div className="admin-user-card">
        <div className="admin-user-left">
          <div className="admin-user-name">
            Welcome, {currentUser.fullname}
          </div>
          <div className="admin-user-role">
            System Role: {currentUser.systemRole}
          </div>
        </div>

        <div className="admin-user-right">
          <div className="admin-user-date">
            {formatDate(serverTime.fullDateTime)}
          </div>
          <div className="admin-user-time">
            {formatTime(serverTime.fullDateTime)}
          </div>
        </div>
      </div>

      {/* PAGE TITLE */}
      <h1 className="admin-dashboard-title">
        Main Dashboard
      </h1>

      {/* ACTION BUTTONS */}
      <div className="admin-dashboard-actions">

        <button
          className="dashboard-btn primary"
          onClick={() => navigate("/admin-panel/pending-registrations")}
        >
          Pending Registrations
        </button>

        <button
          className="dashboard-btn secondary"
          onClick={() => navigate("/admin-panel/current-members")}
        >
          Current Members
        </button>

        <button
          className="dashboard-btn secondary"
          onClick={() => navigate("/admin-panel/manage-alumni")}
        >
          Manage Alumni
        </button>

      </div>

      {/* STATS CARDS */}
      <div className="dashboard-cards">

        <div className="dashboard-card">
          <div className="card-icon">
            <Users size={28} />
          </div>

          <div className="card-content">
            <div className="card-title">
              Total Current Members
            </div>

            <div className="card-number">
              {loading ? "..." : stats.totalApprovedAlumni}
            </div>
          </div>
        </div>

        <div className="dashboard-card">
          <div className="card-icon">
            <FolderKanban size={28} />
          </div>

          <div className="card-content">
            <div className="card-title">
              Total Projects
            </div>

            <div className="card-number">
              {loading ? "..." : stats.totalProjects}
            </div>
          </div>
        </div>

        <div className="dashboard-card">
          <div className="card-icon">
            <Briefcase size={28} />
          </div>

          <div className="card-content">
            <div className="card-title">
              Total Jobs Posted
            </div>

            <div className="card-number">
              {loading ? "..." : stats.totalJobs}
            </div>
          </div>
        </div>

      </div>

    </div>
  );
}